import React from 'react';
import { Trans } from '@lingui/react/macro';
import { ViewMode } from '../../types/api';
import {
  canExportFiles,
  generateRSSDownloadURL,
  useRequestFileDownload,
  type FileDownloadFormat,
} from '../../services/downloads';
import { useCurrentUser } from '@/services/userHooks';

interface DownloadOptionsProps {
  mode?: ViewMode;
  folderId?: string;
  tagSlug?: string;
  closePopover?: () => void;
}

function DownloadOptions({
  mode = 'home',
  folderId,
  tagSlug,
  closePopover,
}: DownloadOptionsProps) {
  const { currentUser } = useCurrentUser();
  const fileDownload = useRequestFileDownload();
  const showFileOptions = canExportFiles(mode);
  const rssURL = generateRSSDownloadURL(mode, currentUser, folderId, tagSlug);

  const handleFileDownload = (format: FileDownloadFormat) => {
    fileDownload.mutate({ format, folderId, tagSlug });
    closePopover?.();
  };

  const handleRSSDownload = (e: React.MouseEvent, downloadURL: string) => {
    e.preventDefault();
    window.open(downloadURL, '_blank');
    closePopover?.();
  };

  return (
    <>
      {/* Download Heading */}
      <div className="menu-header">
        <Trans>Download</Trans>
      </div>

      {/* Download Options */}
      <div className="flex flex-col">
        {showFileOptions && (
          <button
            onClick={() => handleFileDownload('epub')}
            disabled={fileDownload.isPending}
            className="menu-item"
          >
            <span>ePub</span>
          </button>
        )}
        {showFileOptions && (
          <button
            onClick={() => handleFileDownload('pdf')}
            disabled={fileDownload.isPending}
            className="menu-item"
          >
            <span>PDF</span>
          </button>
        )}
        {rssURL && (
          <button onClick={(e) => handleRSSDownload(e, rssURL)} className="menu-item">
            <span>RSS</span>
          </button>
        )}
      </div>
    </>
  );
}

export default DownloadOptions;
